import { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Input, Button, Typography, Alert, Result, Grid } from "antd";
import service from "../../api/fetchInterceptor";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const PortalForgotPassword = () => {
  const screens  = useBreakpoint();
  const isMobile = !screens.md;
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState(null);
  const [form]  = Form.useForm();

  const onFinish = async ({ email }) => {
    setLoading(true); setError(null);
    try {
      await service.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(e?.response?.data?.message || "No se encontró una cuenta con ese email.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#f0f2f5", padding: 20 }}>
        <Result
          status="success"
          title="Email enviado"
          subTitle="Revisa tu correo y sigue el enlace para restablecer tu contraseña. Si no lo ves, revisa la carpeta de spam."
          extra={[
            <Link to="/portal/login" key="login">
              <Button type="primary" style={{ background: "#1d3557" }}>
                Volver al inicio de sesión
              </Button>
            </Link>,
          ]}
        />
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh", display: "flex",
      justifyContent: "center", alignItems: isMobile ? "flex-start" : "center",
      background: "#f0f2f5", padding: isMobile ? "32px 20px" : "20px",
    }}>
      <div style={{
        background: "white", borderRadius: 16, width: "100%", maxWidth: 420,
        padding: isMobile ? "28px 24px" : "40px",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            background: "linear-gradient(135deg, #1d3557, #457b9d)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 16px",
          }}>
            <img
              src="/logo.png" alt="Notaría"
              style={{ height: 38, objectFit: "contain", filter: "brightness(0) invert(1)" }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </div>
          <Title level={3} style={{ color: "#1d3557", marginBottom: 6 }}>Recuperar contraseña</Title>
          <Text type="secondary" style={{ fontSize: 14 }}>
            Te enviaremos un enlace a tu email para restablecer tu contraseña.
          </Text>
        </div>

        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}

        <Form form={form} layout="vertical" onFinish={onFinish} size="large">
          <Form.Item
            label="Email registrado" name="email"
            rules={[
              { required: true, message: "Ingresa tu email" },
              { type: "email", message: "Email inválido" },
            ]}
          >
            <Input placeholder="tu@email.com" autoComplete="email" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary" htmlType="submit" block loading={loading}
              style={{ height: 46, background: "#1d3557", borderColor: "#1d3557", borderRadius: 8 }}
            >
              Enviar enlace
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: "center" }}>
          <Link to="/portal/login" style={{ color: "#457b9d", fontSize: 14 }}>
            ← Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PortalForgotPassword;
